import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { CreateGeoFenceModel, GeoFenceModel } from '../models/geofence.model';
import {environment} from "../../environments/environment";
import { TractorModel } from "../models/tractor.model";

@Injectable()
export class GeoFenceDataSource {

  constructor(
    private http: HttpClient
  ) {
  }

  getAllGeoFences(): Observable<GeoFenceModel[]> {
    return this.http.get<GeoFenceModel[]>(environment.backendApi + 'api/GeoFence/GetGeoFences');
  }

  getGeoFences(terminalId: number): Observable<GeoFenceModel[]> {
    return this.http.get<GeoFenceModel[]>(environment.backendApi + 'api/GeoFence/GetGeoFences/' + terminalId);
  }

  create(body: CreateGeoFenceModel): Observable<GeoFenceModel> {
    return this.http.post<GeoFenceModel>(environment.backendApi + 'api/GeoFence', body);
  }

  update(body: CreateGeoFenceModel, id: number): Observable<GeoFenceModel> {
    return this.http.put<GeoFenceModel>(environment.backendApi + `api/GeoFence/${id}`, body);
  }

  delete(id: number): Observable<number> {
    return this.http.delete<number>(environment.backendApi + `api/GeoFence/${id}`);
  }
}
